var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export default (function (_a) {
    var _b = _a.rotate, rotate = _b === void 0 ? false : _b, _c = _a.fill, fill = _c === void 0 ? '#22272D' : _c, _d = _a.size, size = _d === void 0 ? 24 : _d;
    return (_jsx("svg", __assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", style: rotate ? { transform: 'rotate(180deg)' } : {} }, { children: _jsx("path", { d: "M17.6706 10.0518L12.8944 14.8618C12.6276 15.0985 12.3194 15.215 12.0113 15.215C11.7031 15.215 11.3958 15.0976 11.1609 14.8627L6.3847 10.0527C6.00721 9.70981 5.90423 9.19123 6.09039 8.74405C6.27655 8.29687 6.71539 8 7.20128 8H16.7875C17.2737 8 17.7126 8.2924 17.899 8.74217C18.0854 9.19194 18.0163 9.70981 17.6706 10.0518Z", fill: fill }) })));
});
